import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { PixKeysProps } from "@/models";
import { CopyIcon, DocumentIcon, EmailIcon, PhoneIcon, RandomIcon } from "@/styles/icons";
import { TrashIcon2 } from "@/styles/icons/TrashIcon2";
import { copyTextToClipboard } from "@/utils";
import { Box, Flex, Text, Table, Tr, Tbody, Td, Center, Button, useOutsideClick } from "@chakra-ui/react";
import { Loading } from "barte-design-system";
import { useRef, useState } from "react";
import { BsThreeDots } from "react-icons/bs";
interface PixKeysTableProps { 
    isLoading: boolean;
    data: PixKeysProps[];
    deleteKey: (id: string, keyType: string) => void;
}
export default function PixKeysTable({ isLoading, data, deleteKey }: PixKeysTableProps) {
    const [isOpenPopoverId, setIsOpenPopoverId] = useState(null);
    const moreOptionsButtonRef = useRef();
    const { execute, loading } = useAsyncFunction(deleteKey);
    useOutsideClick({
        ref: moreOptionsButtonRef,
        handler: () => setIsOpenPopoverId(null),
    })
    const getKeyTypeIcon = (type?: string) => {
        const KeyType = {
            email: <EmailIcon size={24} />,
            phone: <PhoneIcon size={24} />,
            evp: <RandomIcon size={24} />,
            cnpj: <DocumentIcon size={24} />,
        };
        return KeyType[type] || type;
    };
    const getKeyType = (type?: string) => {
        const KeyType = {
          email: "Email",
          phone: "Celular",
          evp: "Aleatória",
          cnpj: "CNPJ",
        };
        return KeyType[type] || type;
    };
    
    return (
        <Box
            bgColor="white"
            borderWidth="1px"
            borderRadius="6px"
            borderColor="gray.50"
            p={5}
        >
        {isLoading ? (
            <Center h="200px">
                <Loading type="page" />
            </Center>
        ) : data.length === 0 ? (
            <Center h="200px">
                <Text color="gray.500">Sem lançamentos</Text>
            </Center>
        ) : (
            <Table>
                <Tbody>
                    {data.map((item, idx) => (
                    <Tr key={idx}>
                        <Td w="100%">
                        <Flex
                            w="100%"
                            align="center"
                            gap="1rem"
                        >
                            {getKeyTypeIcon(item?.keyType)}
                            <Flex
                                flexDir="column"
                            >
                                <Text
                                    fontSize=".8rem"
                                    color="newGray.400"
                                >
                                    {getKeyType(item?.keyType)}
                                </Text>
                                <Text
                                    fontSize="1rem"
                                >
                                    {item?.key}
                                </Text>
                            </Flex>
                        </Flex>
                        </Td>
                        <Td w="10%">
                            <Flex
                                position="relative"
                                
                            >
                                <Button
                                    onClick={() => isOpenPopoverId === item.id ? setIsOpenPopoverId(null) : setIsOpenPopoverId(item.id)}
                                    bg="transparent"
                                >
                                    <BsThreeDots size={20}/>
                                </Button>
                                {isOpenPopoverId === item.id && (
                                    <Flex
                                        w="180px"
                                        flexDir="column"
                                        gap=".5rem"
                                        position="absolute"
                                        zIndex={1}
                                        left="20%"
                                        top="100%"
                                        bg="white"
                                        border="1px solid"
                                        borderRadius="6px"
                                        borderColor="gray.200"
                                        p=".8rem"
                                        transform="translateX(-50%)"
                                        ref={moreOptionsButtonRef}
                                    >
                                        <Button
                                            borderRadius="4px"
                                            bgColor="transparent"
                                            onClick={() => {
                                                copyTextToClipboard(item?.key);
                                            }}
                                        >
                                            <Flex
                                                align="center"
                                                gap=".5rem"
                                            >
                                                <CopyIcon />
                                                <Text
                                                    fontWeight={400}
                                                >
                                                    Copiar chave
                                                </Text>
                                            </Flex>
                                        </Button>
                                        <Button
                                            borderRadius="4px"
                                            bgColor="transparent"
                                            onClick={() => execute(item?.key, item?.keyType)}
                                            isDisabled={loading}
                                            isLoading={loading}
                                        >
                                            <Flex
                                                align="center"
                                                gap=".5rem"
                                            >
                                                <TrashIcon2 
                                                    color="#FF4D4F"
                                                />
                                                <Text
                                                    color="#FF4D4F"
                                                    fontWeight={400}
                                                >
                                                    Excluir chave
                                                </Text>
                                            </Flex>
                                        </Button>
                                    </Flex>
                                )}
                            </Flex>
                        </Td>
                    </Tr>
                    ))}
                </Tbody>
            </Table>
        )}
        </Box>
    );
}
